import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { useTimeLynxxTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  showTooltip?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  showTooltip = true, 
  size = 'medium' 
}) => {
  const { mode, toggleMode } = useTimeLynxxTheme();

  const toggleButton = (
    <IconButton
      onClick={toggleMode}
      color="inherit"
      size={size}
      aria-label={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}
    >
      {mode === 'light' ? <DarkMode /> : <LightMode />}
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
        {toggleButton}
      </Tooltip>
    );
  }

  return toggleButton;
};